export const GET_CODE_UOM_List = "GET_CODE_UOM_List";
export const SET_CODE_UOM_List = "SET_CODE_UOM_List";
export const CLEAR_CODE_UOM_List = "CLEAR_CODE_UOM_List";
